interface UsageStripProps {
  remaining: number;
}

export function UsageStrip({ remaining }: UsageStripProps) {
  return (
    <div className="usage-strip" aria-live="polite">
      <span className={`usage-count ${remaining <= 1 ? 'low' : ''}`}>
        今天还能玩 <strong>{remaining}</strong> 次
      </span>
      <span>用完了可升级解锁更多</span>
    </div>
  );
}
